export default function MenuPageItem({ iconClassName, text, onClick }) {

    function handleOnClick(e) {
        if (!onClick)
            return;

        onClick();
    }

    return (
        <li className="menu-page-item" onClick={handleOnClick}>
            {iconClassName ? <i className={iconClassName} ></i> : null}
            <span className="menu-page-item-text">{text}</span>
        </li>
    );
}